import { api } from "@/lib/api"
import type { COUNTRIES_LISINTG, STATES_LISTING } from "@/types/form-types"
import { useQuery, useSuspenseQuery } from "@tanstack/react-query"

export default function useLocationData() {
	const useCountries = () => {
		return useSuspenseQuery({
			queryFn: async () => {
				const { data } = await api.get<COUNTRIES_LISINTG>("/countries")
				return data.data
			},
			queryKey: ["countries"],
		})
	}

	const useGetStatesByCountry = (country: string) => {
		return useQuery({
			queryFn: async () => {
				const { data } = await api.get<STATES_LISTING>(
					`countries/${country}`,
				)
				return data.data
			},
			queryKey: ["states", country],
			enabled: !!country,
		})
	}

	return {
		useCountries,
		useGetStatesByCountry,
	}
}
